import reduceReducers from "reduce-reducers";
import { getApiReducer } from "redux-store/api-sagas";
import { deleteById, reduceById } from "redux-store/reducers";

import {
  DELETE_SCHEDULED_DEPLOYMENT_SUCCESS,
  EDIT_SCHEDULED_DEPLOYMENT_SUCCESS,
  LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS,
  SCHEDULE_DEPLOYMENT_SUCCESS,
  UNLOAD_SCHEDULED_DEPLOYMENTS,
} from "./actions";

const initialState = {};

function scheduledDeploymentsMainReducer(state = initialState, action) {
  const { type, payload = {} } = action;

  switch (type) {
    case EDIT_SCHEDULED_DEPLOYMENT_SUCCESS:
      return {
        ...state,
        byId: reduceById(state.byId, [payload.data]),
      };
    case SCHEDULE_DEPLOYMENT_SUCCESS:
      return {
        ...state,
        byId: reduceById(state.byId, [payload.data]),
      };
    case DELETE_SCHEDULED_DEPLOYMENT_SUCCESS: {
      return {
        ...state,
        byId: deleteById(state.byId, [{ id: payload.data }]),
      };
    }
    case UNLOAD_SCHEDULED_DEPLOYMENTS:
      return initialState;
    default:
      return state;
  }
}

const scheduledDeploymentsLoadReducer = getApiReducer(
  LOAD_SCHEDULED_DEPLOYMENTS_SUCCESS,
);
const scheduledDeploymentsReducer = reduceReducers(
  scheduledDeploymentsMainReducer,
  scheduledDeploymentsLoadReducer,
);

export { scheduledDeploymentsReducer };
